import React from 'react'
import { useNavigate } from 'react-router-dom'

import useText from '../../../common/hooks/useText'
import { LandingPageLayout } from '../../../lib/landing-page-layout'
import { LandingMessage } from '../../../lib/landing-message'
import { theme } from '../../../lib/theme'
import { MarkEmailIcon } from '../../../common/icons/mark-email-icon'

export const ChangeOperatorSuccessPage = () => {
    const text = useText()
    const navigate = useNavigate()

    return (
        <LandingPageLayout background={theme.whiteBackground} hideLanguageSelect>
            <LandingMessage
                title={text('lblTransferRequestSent')}
                linkText={text('btnGoToDashboard')}
                onClick={() => {
                    navigate('/dashboard', { replace: true })
                }}
                icon={<MarkEmailIcon />}
            >
                <div data-testid="message">{text('msgTransferRequestSent')}</div>
            </LandingMessage>
        </LandingPageLayout>
    )
}
